<script setup lang="ts">
import { BaseTooltip } from '@/composables/useTooltip';
import { onBeforeMount, watch } from 'vue';
import { RouterView } from 'vue-router';
import { useLocale } from './composables/locale';
import { useAnalyticsUserId } from './composables/useAnalyticsUserId';
import { useNewRelic } from './composables/useNewRelic';
import { useTutorialGuidanceManager } from './composables/useTutorialGuidanceManager';
import { globalConstants } from './constants/global.constants';
// import { BackstageTheme } from './models/backstage-theme.enum';
import { useGridsStore } from './stores/grids';
import { useUserStore } from './stores/user';

const { userProfile, selectedAccountId } = useUserStore();
const { setI18nLocale } = useLocale();
const { $reset: resetGridsStore } = useGridsStore();
const { noticeError } = useNewRelic();

useAnalyticsUserId();
useTutorialGuidanceManager();

/** Depricating below theme code for now. We might enable this feature in future */
/**
function setTheme(theme: BackstageTheme) {
  const rootElement = document.querySelector('body');

  if (rootElement) {
    rootElement.classList.remove(...[BackstageTheme.light, BackstageTheme.dark]);
    rootElement.classList.add(theme);
  }
}

setTheme((userProfile?.user?.theme as BackstageTheme) ?? BackstageTheme.light);

watch(
  () => userProfile?.user?.theme,
  function (newVal) {
    if (newVal && newVal in BackstageTheme) {
      setTheme(newVal as BackstageTheme);
    }
  },
);
*/

watch(
  () => selectedAccountId,
  function (newValue, oldValue) {
    if (newValue !== oldValue) {
      resetGridsStore();
    }
  },
);

onBeforeMount(() => {
  setI18nLocale(userProfile?.user.locale ?? globalConstants.fallBackLocale).catch((error) =>
    noticeError(error, {
      component: 'App',
    }),
  );
});
</script>

<template>
  <RouterView />
  <BaseTooltip />
</template>

<style>
/* all this ones should be inlcuded only on pages where is necessary */
@import '../node_modules/@ag-grid-community/styles/ag-grid.min.css';
@import '../node_modules/@ag-grid-community/styles/ag-theme-balham.min.css';
@import '../node_modules/vue-select/dist/vue-select.css';
@import '@vuepic/vue-datepicker/dist/main.css';
@import './assets/scss/overrides/ag-theme-custom.scss';
@import './assets/scss/overrides/calendar.scss';
@import './assets/scss/overrides/vue-select.scss';
@import './assets/scss/main.scss';
@import './assets/scss/icons.scss';
</style>
